import { api } from "@/infrastructure/api";
import { all, call, put, takeLatest } from "redux-saga/effects";
import * as A from "./actions";
import * as T from "./types";
import { AxiosResponse } from "axios";

export function* fetchTickers({ payload }: ReturnType<typeof A.fetchTickers.request>) {
  try {
    const { data }: AxiosResponse<T.Tickers[]> = yield call(api.get, `/search/yahoo-ticker/${payload}`);

    yield put(A.fetchTickers.success(data));
  } catch (e) {
    yield put(A.fetchTickers.failure());
  }
}

export default function*() {
  yield all([takeLatest(A.fetchTickers.request, fetchTickers)]);
}
